export enum Category {
  'cellphone' = 'telefono',
  'kredicash' = 'kredicash',
}
